<template>
 <Dialog :visible="visible" modal @update:visible="deactivate"
   :style="{ width: '75rem' }" class="mx-4">
      <div v-html="getContent"></div>
  </Dialog>
</template>

<script>
import { Dialog } from 'primevue';

export default {
  name: 'HtmlOverlayComponent',
  components: { Dialog },
  props: {
    overlay: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    getLocale() {
      return this.$i18n.locale;
    },
    getContent() {
      return this.overlay?.content?.html?.[this.getLocale] ?? null;
    },
  },
  methods: {
    deactivate() {
      this.visible = false;
      this.$store.dispatch('deactivateOverlay', this.overlay._id);
    },
  },
};
</script>
